import { combineReducers } from 'redux';
import resendEmailReducer from './ResendEmail/reducer';

export default combineReducers({
  resendEmail: resendEmailReducer,
});
